module.exports = __webpack_public_path__ + "VIPV8.png?4fdaee757d307eb416f5c4b145f1d747";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV8.png
// module id = 141
// module chunks = 0